import React from 'react';
import { Container } from 'react-bootstrap';
import ProductItem from '../../products/components/ProductItem';

function NewArrivalProductSection({ products }) {
    return (
        <section className="new-product-section">
            <Container>
                <h4 className="custom-typo">
                    <span>New Products</span>
                </h4>
                <div className="row row-m-product">
                    {products &&
                        products.slice(0, 10).map((item) => (
                            <div
                                className="col mb-4 col-m-product new-product-section-colI5"
                                key={item.id}
                            >
                                <ProductItem itemData={item} />
                            </div>
                        ))}
                </div>
            </Container>
        </section>
    );
}

export default NewArrivalProductSection;
